import { render, staticRenderFns } from "./AbandonProgramComponent.vue?vue&type=template&id=8882f43e&"
import script from "./AbandonProgramComponent.vue?vue&type=script&lang=js&"
export * from "./AbandonProgramComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports